import PropTypes from 'prop-types'
import './styles.css'
import { imageFileRenderHelper } from '@thelpers/imageFileRenderHelper'

const ComprobantDetailPaymentBodyImageDetail = ({
  comprobantDetailData
}) => {
  return (
    <div className='comprobant-detail-payment-body-image-detail'>
      {
        imageFileRenderHelper({
          link: true,
          file: comprobantDetailData?.file,
          svgProps: { width: 140, height: 150 },
          imageProps: { width: 275, height: 285 }
        })
      }
      <div className='comprobant-detail-payment-body-image-detail-info'>
        <div>
          <strong>Fecha de emisión</strong>
          <p>---</p>
        </div>
        <div>
          <strong>Fecha de vencimiento</strong>
          <p>---</p>
        </div>
        <div>
          <strong>Fecha de pago</strong>
          <p>{comprobantDetailData?.payment_date}</p>
        </div>
        <div>
          <strong>Última modificación</strong>
          <p>{comprobantDetailData?.updated_by}</p>
        </div>
      </div>
    </div>
  )
}

ComprobantDetailPaymentBodyImageDetail.propTypes = {
  comprobantDetailData: PropTypes.object
}

export default ComprobantDetailPaymentBodyImageDetail
